import type { TInsightsTableData } from '../../components/BenchmarkingTableColumns';

import type { TBenchmarkingRates } from './types';

export const mapRates = (
  rates: TBenchmarkingRates,
  id: string,
  name?: string,
  practiceId?: string,
  practiceName?: string,
): TInsightsTableData => {
  return {
    name: name ?? '',
    id,
    practiceName,
    practiceId,
    completedTreatments: rates.completedProduction,
    opportunity: rates.opportunity,
    acceptedRate: rates.acceptanceRate,
    plannedRate: rates.plannedRate,
    previousCompletedTreatments: rates.previousCompletedProduction,
    previousOpportunity: rates.previousOpportunity,
    previousAcceptedRate: rates.previousAcceptanceRate,
    previousPlannedRate: rates.previousPlannedRate,
    conversionRate: rates.conversionRate,
    previousConversionRate: rates.previousConversionRate,
    completedRate: rates.completionRate,
    previousCompletedRate: rates.previousCompletionRate,
    viewedRate: rates.viewedRate,
    previousViewedRate: rates.previousViewedRate,
  };
};
